import styles from './Receipt.module.scss';

export const ReceiptGroup = (props) => <div className={styles.group} {...props} />;
